export default __webpack_public_path__ + "static/media/gobiernocantabrialogo.e6044a17.png";